
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, Lock, Eye, FileText, Crown } from 'lucide-react';

const PrivacyPolicyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#02040a] text-white font-sans selection:bg-purple-500/30">
      {/* Background Glow */}
      <div className="fixed top-[-10%] right-[-10%] w-[500px] h-[500px] bg-purple-600/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="max-w-4xl mx-auto px-6 py-20 relative z-10">
        <button 
          onClick={() => navigate(-1)} 
          className="mb-12 flex items-center gap-3 text-gray-500 hover:text-white transition-all font-black text-[10px] uppercase tracking-widest"
        >
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>

        <header className="mb-20">
          <div className="w-16 h-16 bg-purple-600/20 rounded-2xl flex items-center justify-center text-purple-500 mb-6 border border-purple-500/20 shadow-2xl">
            <ShieldCheck className="w-8 h-8" />
          </div>
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter leading-none mb-4 uppercase">POLÍTICA DE <br/> <span className="text-purple-500">PRIVACIDADE</span></h1>
          <p className="text-gray-500 font-bold uppercase text-[10px] tracking-[0.3em]">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
        </header>

        <div className="space-y-16">
          <Section 
            icon={Lock} 
            title="Segurança de Dados" 
            content="Na HeroFrog, a segurança é prioridade máxima. Utilizamos criptografia de ponta a ponta para proteger as informações da sua empresa e dos seus clientes. Seus dados são armazenados em infraestrutura de classe mundial com monitoramento 24/7."
          />
          
          <Section 
            icon={Eye} 
            title="Transparência e Coleta" 
            content="Coletamos apenas as informações estritamente necessárias para a operação da sua landing page e pagamentos. Nunca vendemos seus dados para terceiros."
          />

          <Section 
            icon={Crown} 
            title="Uso da Inteligência Artificial" 
            content="Nossos modelos de IA processam o prompt que você fornece para gerar o conteúdo da sua página. O conteúdo gerado é de sua propriedade exclusiva."
          />

          <div className="bg-white/[0.02] border border-white/5 p-10 rounded-[3rem] space-y-6">
            <h3 className="text-xl font-black uppercase tracking-tighter">Termos Rápidos</h3>
            <ul className="space-y-4 text-gray-400 font-medium text-sm">
              <li className="flex items-start gap-3"><span className="text-purple-500 font-black">•</span> Você tem controle total sobre a exclusão dos seus dados a qualquer momento.</li>
              <li className="flex items-start gap-3"><span className="text-purple-500 font-black">•</span> O login via Google serve apenas para autenticação e segurança da sua conta.</li>
              <li className="flex items-start gap-3"><span className="text-purple-500 font-black">•</span> Utilizamos cookies para melhorar a performance do seu dashboard.</li>
            </ul>
          </div>
        </div>

        <footer className="mt-20 pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2 text-xl font-black">
              <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center">
                <Crown className="w-5 h-5 text-white" />
              </div>
              HeroFrog<span className="text-purple-500">.</span>
          </div>
          <p className="text-gray-600 font-black text-[9px] uppercase tracking-widest">Compliance LGPD & GDPR Ready</p>
        </footer>
      </div>
    </div>
  );
};

const Section = ({ icon: Icon, title, content }: any) => (
  <section className="space-y-4">
    <div className="flex items-center gap-3">
      <Icon className="w-5 h-5 text-purple-500" />
      <h2 className="text-xl font-black uppercase tracking-widest text-white">{title}</h2>
    </div>
    <p className="text-gray-400 font-medium leading-relaxed text-lg pl-8">{content}</p>
  </section>
);

export default PrivacyPolicyPage;